import React from 'react';
import { useEffect, useRef, useState, createRef } from 'react'
import { useParams, useNavigate,  } from 'react-router-dom'
import {
  SActionBtn,
  SLowcodeList,
  SDrawer,
  SIDRender,
  STriggerModal
} from 'shj-components'
import config from './config';
import { Button, Form, DatePicker, Modal, message, Input, Table } from 'antd'
import dayjs from 'dayjs'
import styles from '../receivableList/index.module.less'
import { transactionJournalFindResponseListByPageForMainPage,httpDictServTenant, 
  getEnum, comfireToAccountBatch, transactionJournalComfireToAccount} from '@/services/fmsServices';
export default function PaymentServiceManage() {
  const history = useNavigate();
  let [form] = Form.useForm();
  const listRef = useRef<any>();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [confirmReceiptList, setConfirmReceiptList] = useState([] as any[]);
  const [selectedRows, setSelectedRows] = useState([] as any[]);
  // 计算选中数据的合计金额
  const getTotalAmount = () => {
    return selectedRows.reduce((total: number, row: any) => {
      // 确保金额是数字类型
      const amount = parseFloat(row.amount || '0');
      return total + (isNaN(amount) ? 0 : amount);
    }, 0);
  };
  // 表格加载
  const fetchList = (values: any) => {
    const { current, pageSize, ...rest } = values;
    return new Promise(async (resolve, reject) => {
      try {
        const { current, pageSize, query } = values
        const { paymentMethodList, verifyStateList, stateList, transactionTypeList } = query
        if (query.receivedDate) {
          query.receivedDateStart = dayjs(query.receivedDate[0]).format('YYYY-MM-DD 00:00:00')
          query.receivedDateEnd = dayjs(query.receivedDate[1]).format('YYYY-MM-DD 23:59:59')
        }
        if (query.confirmDate) {
          query.accountingDateStart = dayjs(query.confirmDate[0]).format('YYYY-MM-DD 00:00:00')
          query.accountingDateEnd = dayjs(query.confirmDate[1]).format('YYYY-MM-DD 23:59:59')
        }
        // 将单值转换为数组形式
        paymentMethodList && (query.paymentMethodList = [paymentMethodList]);
        // verifyStateList && (query.verifyStateList = [verifyStateList]);
        stateList && (query.stateList = [stateList]);
        transactionTypeList && (query.transactionTypeList = [transactionTypeList]); 
        transactionJournalFindResponseListByPageForMainPage(current, pageSize, query).then((res)=>{
          resolve(res)
        })
      } catch (e) {
        reject({ success: false });
      }
    });
  };

  // 查看
  const onInfo = (record = {}) => {

  }
  // 刷新
  const reloadFn = () => {
    const {
      current: { reload },
    } = listRef;
    reload();
  };
  const onConfirmReceiptShowModal = ({selectedRowKeys, selectedRows}) => {
    setConfirmReceiptList(selectedRowKeys)
    setSelectedRows(selectedRows)
    setOpen(true)
  }
  // 监听表格选择变化
  const onSelectChange = (selectedRowKeys: any[], selectedRows: any[]) => {
    setSelectedRows(selectedRows);
  }
  const onConfirmReceipt = () => {
    form.validateFields().then(async (values: any) => {
      let confirmDate = dayjs(values.confirmDate).format('YYYY-MM-DD HH:mm:ss')
      setLoading(true)
      if(confirmReceiptList.length > 0){
        comfireToAccountBatch({
          receiptId: confirmReceiptList, 
          confirmDate,
        }).then((res)=>{
          message.success(res.message || '批量确认到账成功')
          reloadFn()
          setOpen(false)
          setLoading(false)
        }).catch(err=>{
          setLoading(false)
        })
      }
    })
  }
  const getStatusOptions = () => {
    return new Promise(async resolve => {
      //支付方式 去掉在线支付
    const paymentMethodList: any = await httpDictServTenant({
      parentKey: 'paymentMethod',
      enabled: 1,
      orderBys: [
        {
          "columnName": "sortNumber",
          "asc": true
        }
      ]
    }).then((list: any) => list.filter((item) => item.priKey !== 'onlinePay'))
    //交易类型
    const transactionFeeTypeList: any = await httpDictServTenant({
      parentKey: 'transactionFeeType',
      enabled: 1,
    })
    const verifyStateList: any = await getEnum('com.shj.saas.plus.fms.enums.VerifyStateEnum')
    const receiptStateList: any = await getEnum('com.shj.saas.plus.fms.enums.PaymentsDetailStatusEnum')
      resolve({
        customerReceiptFlagList: [
          { name: '是', id: '1' },
          { name: '否', id: '0' },
        ],
        paymentMethodList,
        transactionFeeTypeList,
        verifyStateList,
        receiptStateList
      })
    })
  }
  // 右侧表格配置
  const extension = {
    request: { fetchList, getStatusOptions },
    events: {onConfirmReceiptShowModal},
    customRender: {
      clueIdRender(text: any, record: any) {
        return (
          <SIDRender id={text} onClick={() => onInfo(record)} copy={false}></SIDRender>
        )
      },
      receiptFlagOperate(text: any, record: any) {
        return text ? '是' : '否'
      },
    },
  }
  return (
    <div className={styles.FmsDragTable}>
      <SLowcodeList config={config} ref={listRef} {...extension} 
        searchMode="group"
        onSelectedRowChange={onSelectChange}
        footerLeft={
          <div style={{ fontWeight: 'bold', color: '#e74c3c', fontSize: '16px', padding: '10px' }}>
            收款金额合计: ¥{getTotalAmount().toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
          </div>
        }
      />
      {/* 确认到账 */}
      <STriggerModal
        title={confirmReceiptList.length > 0 ? '批量确认到账' : '确认到账'}
        cancelText="取消"
        okText="确定"
        open={open}
        confirmLoading={loading}
        onOk={onConfirmReceipt}
        onCancel={() => setOpen(false)}
        destroyOnClose
      >
        <Form form={form}>
          <Form.Item label="到账日期" name="confirmDate" rules={[{ required: true }]}>
            <DatePicker showTime={{ defaultValue: dayjs()}}  />
          </Form.Item>
        </Form>
      </STriggerModal>
    </div>
  )
}
